// $FlowFixMe

import * as React from 'react';

export const Footer = () => (
  <div />
);

export default Footer;
